import { css, SerializedStyles } from '@emotion/react';
import { colors } from '@airwallex/global';

const { ultraViolet, greys, white } = colors;

export const containerCss = (): SerializedStyles => css`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const checkboxCss = (checked: boolean): SerializedStyles => css`
  width: 16px;
  height: 16px;
  display: inline-flex;
  border: 2px solid ${checked ? ultraViolet : greys[40]};
  border-radius: 3px;
  align-items: center;
  justify-content: center;
  background: ${checked ? ultraViolet : white};
  &:hover {
    border: 2px solid ${ultraViolet};
  }
`;

export const checkboxInputCss = (isDisabled: boolean): SerializedStyles => css`
  position: absolute;
  opacity: 0;
  height: 16px;
  width: 16px;
  margin: 0;
  cursor: ${isDisabled ? 'not-allowed' : 'pointer'};
`;

export const checkboxLabelCss = (): SerializedStyles => css`
  margin-left: 8px;
`;
